import React, {
  Context,
  createContext,
  Dispatch,
  useContext,
  useState,
} from "react";
import { AlertColor } from "@mui/lab/Alert";
import Toast from "fe-web-components/layout/toast";

export type ClinicMessage = {
  text: string | React.ReactNode;
  severity?: AlertColor;
};

export type ClinicMessagesContextApi = {
  message: ClinicMessage;
  setMessage: Dispatch<ClinicMessage>;
};
const ClinicMessagesContext: Context<ClinicMessagesContextApi> = createContext<
  ClinicMessagesContextApi
>(null);
export const useClinicMessagesContext = () => useContext(ClinicMessagesContext);

export const ClinicMessagesProvider = ({ children }: { children?: any }) => {
  const [toastMsg, setToastMsg] = useState<ClinicMessage>(null);

  return (
    <ClinicMessagesContext.Provider
      value={{ message: toastMsg, setMessage: setToastMsg }}
    >
      {children}
      <Toast
        open={!!toastMsg?.text}
        text={toastMsg?.text}
        severity={toastMsg?.severity}
        onClose={() => setToastMsg(null)}
        duration={2000}
      />
    </ClinicMessagesContext.Provider>
  );
};
